import { render, staticRenderFns } from "./ProfilePhoneEdit.vue?vue&type=template&id=69220432&scoped=true"
import script from "./ProfilePhoneEdit.vue?vue&type=script&lang=js"
export * from "./ProfilePhoneEdit.vue?vue&type=script&lang=js"
import style0 from "./ProfilePhoneEdit.vue?vue&type=style&index=0&id=69220432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69220432",
  null
  
)

export default component.exports